import React from 'react';
import { useSettings } from './context';
import { API } from '../../utils/helpers';
import UserManagement from '../UserManagement';

// Users — extracted from Settings.jsx on 17 Sep 2026. The markup is
// unchanged; every value it needs comes from the Settings context rather than
// from props, so this move could not alter behaviour.
export default function SettingsUsers() {
  const { T, currentUser, theme } = useSettings();
  return (
    <>
     {/* ── User Management (Owner only) ── */}
     {currentUser?.role === 'owner' && (
       <UserManagement theme={theme} T={T} API={API} />
     )}
    </>
  );
}
